export const zeroPadd = num => `0${num}`.slice(-2);

export const currentDate = () => dateToObj(new Date());
export const dateToObj = d => ([d.getFullYear(), d.getMonth() + 1, d.getDate()]);

export const initialMonth = () => {
    const [year, month] = currentDate();
    return [year, month];
};

export const changeMonth = ([year, month], value) => {
    month += value;

    while(month <= 0){
        year--;
        month += 12;
    }

    while(month >= 13){
        year++;
        month -= 12;
    }

    return [year, month];
};

export const changeMonthByOne = (month, value) => {
    value /= Math.abs(value);
    return changeMonth(month, value);
};

export const mountInterval = month => {
    const interval = [];
    let weekDay = monthWeekdayStart(month);

    if(weekDay > 0){
        const previousMonth = changeMonthByOne(month, -1);
        let previousDate = monthTotalDays(previousMonth) - (weekDay - 1);
        for(let diff = weekDay; diff--; previousDate++)
            interval.push(newDate(...previousMonth, previousDate));
    }

    for(let d = 1, total = monthTotalDays(month); d <= total; d++){
        interval.push(newDate(...month, d, true));
        weekDay = (weekDay + 1) % 7;
    }

    if(weekDay > 0){
        const nextMonth = changeMonthByOne(month, 1);
        for(let d = 1; weekDay < 7; d++){
            interval.push(newDate(...nextMonth, d));
            weekDay++;
        }
    }

    return interval;
};

export const newDate = (year, month, date, highlight = false) => {
    const monthStr = zeroPadd(month);
    const dateStr = zeroPadd(date);

    const dateString = [year, monthStr, dateStr].join('-');

    return { year, month, date, dateString, highlight };
};

export const monthTotalDays = ([year, month]) => {
    switch(month){
    case 4: case 6: case 9: case 11:
        return 30;
    case 2:
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0 ? 29 : 28;
    default:
        return 31;
    }
};

export const monthWeekdayStart = ([year, month]) => {
    const d = new Date(year, month - 1, 1);
    return d.getDay();
};

export const checkDate = (obj, date) =>
    obj.year === date.getFullYear() &&
    obj.month === date.getMonth() + 1 &&
    obj.date === date.getDate();

export const parseDate = str => {
    const d = new Date(str);
    d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
    return d;
};

export const dateFromString = str => {
    const [dateStr, monthStr, yearStr] = str.split('/');
    return newDate(yearStr, monthStr, dateStr);
};

export const dateFromDateString = str => {
    const [yearStr, monthStr, dateStr] = str.split('-');
    return newDate(yearStr, monthStr, dateStr);
};

export const formatDate = ({ date, month, year }) => [zeroPadd(date), zeroPadd(month), year].join('/');

export const weekdayNames = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
export const weekdayName = num => weekdayNames[num - 1];

export const monthNames = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
const monthName = num => monthNames[num - 1];
export const formattedMonthName = ([year, month]) => `${monthName(month)}/${year}`;

export const formattedDateName = ({ date, month }) => `${zeroPadd(date)}/${monthName(month)}`;
